module.exports = __webpack_public_path__ + "img/6-1.58be5709.png";